
class LastProjectService {
  getId() {
    if (typeof window !== "undefined" && localStorage.getItem("lastProject") !== 'undefined') {
      const project = JSON.parse(window.localStorage.getItem("lastProject"))
      return project?.id;
    }
  }
  getProject() {
    if (typeof window !== "undefined" && localStorage.getItem("lastProject") !== 'undefined') {
      const project = JSON.parse(window.localStorage.getItem("lastProject"))
      return project?.project;
    }
  }
  getDate() {
    if (typeof window !== "undefined" && localStorage.getItem("lastProject") !== 'undefined') {
      const project = JSON.parse(window.localStorage.getItem("lastProject"))
      return project?.createdDate;
    }
  }
  setProject(project) {
    localStorage.setItem("lastProject", JSON.stringify(project));
  }
  removeProject() {
    localStorage.removeItem("lastProject");
  }
}
export default new LastProjectService();
